import { CA_PURPOSE, DEPARTMENTS } from 'components/WizardTypes/Wizard.types';
import { format } from 'date-fns';
import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import React from 'react';

type renderProps = {
  Comp: any;
  props?: any;
};

export const render = (Comp: any, props: any = {}) => {
  return isReactComponent(Comp) ? <Comp {...props} /> : Comp;
};

const isReactComponent = (component: any) => {
  return (
    isClassComponent(component) || typeof component === 'function' || isExoticComponent(component)
  );
};

const isClassComponent = (component: any) => {
  return (
    typeof component === 'function' &&
    (() => {
      const proto = Object.getPrototypeOf(component);
      return proto.prototype && proto.prototype.isReactComponent;
    })()
  );
};

const isExoticComponent = (component: any) => {
  return (
    typeof component === 'object' &&
    typeof component.$$typeof === 'symbol' &&
    ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description)
  );
};

export const convertToUTC = (value: any) => {
  return value
    ? value.getTimezoneOffset() > 0
      ? new Date(value.setUTCHours(0, 0, 0, 0))
      : new Date(value.setUTCHours(24, 0, 0, 0))
    : null;
};

export const addTimezoneOffset = (date: any) => {
  const newDate = new Date(date);
  newDate.setMinutes(newDate.getMinutes() + newDate.getTimezoneOffset());

  return newDate;
};

export const convertLocalToUTC = (date: any) => {
  // stepping on time to make sure FE submits midnight utc
  return format(date, "yyyy-MM-dd'T00:00:00Z'");
};

// test if str contains only numbers
export const validateNum = (str: string) => {
  return /^\d+$/.test(str);
};

export function stringToBoolean(str: string): boolean {
  const boolMap = new Map<string, boolean>([
    ['true', true],
    ['false', false],
    ['yes', true],
    ['no', false],
    ['1', true],
    ['0', false]
  ]);

  const result = boolMap.get(str.toLowerCase());
  if (result !== undefined) {
    return result;
  } else {
    throw new Error('Invalid boolean string');
  }
}

export const departmentProcessOverviewLabel = (departmentId: number, purposeId: number) => {
  if (departmentId === DEPARTMENTS.CorporateApplications) {
    if (`${purposeId}` === CA_PURPOSE.Applications) {
      return 'ATS';
    }
    const CA_PURPOSE_CHECKS: string[] = [
      CA_PURPOSE.Hardware,
      CA_PURPOSE.InformationSecurity,
      CA_PURPOSE.InfrastructureSoftware
    ];
    if (CA_PURPOSE_CHECKS.includes(`${purposeId}`)) {
      return 'ATS - Information Technology';
    }
    return 'Corporate IT';
  }
  if (departmentId === DEPARTMENTS.Learning) {
    return 'Applied Learning';
  }
  if (departmentId === DEPARTMENTS.CorporateWebsite) {
    return 'Corporate Website';
  }
  return '';
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
